<template>
  <v-sheet min-height="100vh" height="100%" class="top-section secondary">
    <v-sheet
      class="social"
      :class="
        mdAndDown ? `grey-md lighten-2 path-cliped pt-0` : 'transparent pt-3'
      "
    >
      <v-container
        :class="mdAndDown ? `align-center` : `align-start`"
        class="d-flex justify-space-between"
      >
        <img
          :height="xs ? `80px` : `108px`"
          :src="files + informations.img"
          :alt="informations.name"
          class="d-block z-index-prefer relative"
        />
        <div class="links">
          <div
            v-for="({ text, link, icon, size }, keySocial) in social"
            :key="keySocial"
            class="d-inline-flex"
          >
            <v-btn
              class="text-caption text-lg-body-1 white--text ml-4"
              :href="link"
              target="_blank"
              min-width="auto"
              :color="mdAndDown ? `secondary` : `rgba(255, 255, 255, 0.13)`"
              small
              :title="text"
              depressed
              rounded
              fab
            >
              <v-icon :size="size">{{ icon }}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-sheet>
    <v-container>
      <v-row class="relative z-index-prefer mt-8 mt-md-12">
        <v-col cols="12" md="6" class="d-sm-flex justify-sm-center">
          <v-sheet
            max-width="600px"
            :width="mdOnly ? `400px` : smAndDown ? `100%` : `470px`"
            class="
              grey
              elevation-3
              lighten-2
              py-10
              px-8
              py-sm-16
              px-sm-12
              d-flex
              justify-center
              flex-column
            "
          >
            <WhatsAppCtaWidget
              v-if="informations.whatsapp"
              :tel="informations.whatsapp"
            />
          </v-sheet>
        </v-col>
        <v-col cols="12" md="6">
          <div class="d-flex flex-column">
            <div class="primary--text">
              <TitleWidget>{{ banner_top.title }}</TitleWidget>
            </div>
            <div
              class="white--text text-subtitle-1 col-12 col-sm-10 pa-0 mt-4"
              v-html="banner_top.text"
            ></div>

            <div v-if="youtubeLink" class="mt-9">
              <iframe
                width="100%"
                height="319"
                :src="`https://www.youtube.com/embed/` + youtubeLink"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-sheet
      height="100%"
      :width="mdAndDown ? `360px` : `600px`"
      class="grey lighten-2 white-bg-top"
      :class="mdAndDown ? `d-none` : 'd-block'"
    ></v-sheet>
  </v-sheet>
</template>

<script>
import { getYoutubeCode } from "../../utils/getYoutubeCode";
import { getSocial } from "../../utils/getSocial";
import TitleWidget from "../widgets/TitleWidget.vue";
import WhatsAppCtaWidget from "../widgets/WhatsAppCtaWidget.vue";

const _config = {
  mod: "banner-top",
};

export default {
  components: { TitleWidget, WhatsAppCtaWidget },

  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
    youtubeLink() {
      return this.banner_top.video && getYoutubeCode(this.banner_top.video);
    },
    banner_top() {
      return this.$rest(_config.mod).item;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.top-section {
  position: relative;

  &::before {
    content: "";
    height: 360px;
    width: 360px;
    position: absolute;
    right: 180px;
    top: 50%;
    transform: translateY(-50%);
    background-image: url("../../assets/img/register-bg.png");
    background-size: contain;
  }
  .white-bg-top {
    clip-path: polygon(0 0, 100% 0, 80% 100%, 0% 100%);
    position: absolute;
    left: 0;
    top: 0;
  }
  .z-index-prefer {
    z-index: 10 !important;
  }
  .path-cliped {
    clip-path: polygon(0 0, 100% 0, 100% 90%, 0 100%);
  }
}
</style>
